<ng-container *ngIf="isLoading$ | async">
</ng-container>
<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{'ABOUTUS.ABOUTUS' | translate}}</h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.ABOUTUS' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>


<div class="about-area pt-100 pb-70">
    <div class="container">
        <h1 class="bm-section-title" style="color: rgb(38, 37, 37) !important;margin-bottom: 20px;">{{ language == 'en'? 'Balsam Story':' قصة بلسم' }}</h1>
        <div class="row align-items-center" style="margin-top: 30px !important;">
            <div class="col-lg-6">
                <div class="about-item">
                    <div class="about-left">
                        <img src="assets/img/home-one/home-bg4.jpg" alt="About">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="about-item about-right">
                    <h2 style="color: white !important;">{{'ABOUTUS.ABOUTHOSPITAL' | translate}}</h2>
                    <h3 style="color: black !important;">{{ language == 'en'? 'Balsam in Brief ':'بلسم  في سطور' }}</h3>
                    <h4 style="text-align: justify">{{ AboutHospital }}</h4>
                </div>
            </div>
        </div>
        <div class="row align-items-center" style="margin-top: 70px;">
            <h1 class="bm-section-title " style="color: rgb(38, 37, 37) !important;">{{ language == 'en'? 'Geographic Expansion':'التوسع الجغرافي' }}</h1>
            <img src="assets/img/website sliders-05.jpg" alt="About">
        </div>
        <section class="history-box" style="margin-top: 70px;">
            <div class="container-fluid py-4 px-lg-5">

                <h1 class="bm-section-title" style="color: rgb(38, 37, 37) !important;margin-bottom: 20px;">{{ language
                    == 'en'? 'Timeline':'المسار الزمني' }}</h1>

                <!-- شريط السنوات + الأسهم -->
                <div class="years-bar position-relative rounded-4 px-3 py-2">
                    <div class="d-flex align-items-center justify-content-between gap-2">

                        <!-- السابق -->
                        <button class="nav-circle" (click)="prev()" aria-label="السابق">
                            <i *ngIf="language == 'ar'" class="icofont icofont-rounded-right"></i>
                             <i *ngIf="language == 'en'" class="icofont icofont-rounded-left"></i>
                        </button>

                        <!-- قائمة السنوات -->
                        <ul class="years-list d-flex align-items-center justify-content-center flex-wrap m-0 p-0">
                            <li *ngFor="let item of HistoryValues; let i = index" class="year-item"
                                [class.active]="i === current" (click)="select(i)">
                                <span class="year-text">{{ item.year }}</span>

                                <!-- علامة الخط المتقطع والنقطة تحت العام المختار -->
                                <span class="pin" *ngIf="i === current">
                                    <span class="dash"></span>
                                    <span class="dot"></span>
                                </span>
                            </li>
                        </ul>

                        <!-- التالي -->
                        <button class="nav-circle" (click)="next()" aria-label="التالي">
                             <i *ngIf="language == 'ar'" class="icofont icofont-rounded-left"></i>
                             <i *ngIf="language == 'en'" class="icofont icofont-rounded-right"></i>
                        </button>

                    </div>
                    <hr class="years-divider m-0">
                </div>

                <!-- بطاقة المحتوى -->
                <div class="content-card mt-4 p-3 p-md-4 rounded-4 shadow-sm">
                    <div class="row g-4 align-items-center">

                        <!-- الصورة -->
                        <div class="col-md-5">
                            <div class="img-wrap rounded-4 overflow-hidden shadow-sm">
                                <img [src]="HistoryValues[current].image" [alt]="HistoryValues[current].title"
                                    class="w-100 h-100 object-cover">
                            </div>
                        </div>

                        <!-- النص -->
                        <div class="col-md-7">
                            <h3 class="fw-bolder mb-3">{{ HistoryValues[current].title }}</h3>
                            <p class="lead text-secondary mb-0" style="text-align: justify;">
                                {{ HistoryValues[current].desc }}
                            </p>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    </div>
</div>


<!-- Values / قيمنا -->
<section class="bm-values">
    <div class="container">

        <h2 class="bm-section-title">
            {{ language === 'ar' ? 'الأهداف الاستراتيجية' : 'Our Goals' }}
        </h2>

        <!-- Slider -->
        <div class="bm-slider-wrap">
            <div class="bm-slider" #track>
                <article class="bm-card" *ngFor="let v of values">
                    <!-- <div class="bm-icon">
            <img [src]="v.icon" [alt]="v.title" />
          </div> -->
                    <h3 class="bm-card-title">{{ v.title }}</h3>
                    <p class="bm-card-text">{{ v.text }}</p>
                </article>
            </div>

            <!-- Arrows -->
            <button dir="ltr" class="bm-nav bm-prev" (click)="scroll(track, -1)" aria-label="Previous">
                <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" />
                </svg>
            </button>
            <button dir="ltr" class="bm-nav bm-next" (click)="scroll(track, 1)" aria-label="Next">
                <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" />
                </svg>
            </button>
        </div>

    </div>
</section>

<!-- <section class="speciality-area pb-100" >
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-lg-7">
                <div class="speciality-left">
                    <div class="section-title-two">
                    </div>
                    <div class="speciality-item">
                        <div class="row m-0">
                            <div class="col-sm-7 col-lg-7 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                                <div class="speciality-inner">
                                    <h3>{{ language == 'en'? 'OUR MISSION ':'رسالتنا' }}</h3>
                                    <p>{{ language == 'en'? 'We invest in and support a diverse portfolio of distinguished healthcare opportunities. Guided by our core principles of wisdom, integrity, impact, and relentless pursuit of excellence. We strive to achieve sustainable growth and add value for our shareholders while supporting solutions that enhance life.':
                                        'نستثمر وندعم محفظة متنوعة من فرص الرعاية الصحية المتميزة. مسترشدين بمبادئنا الأساسية المتمثلة في الحكمة والنزاهة والتأثير والسعي الحثيث لتحقيق التميز. نسعى جاهدين لتحقيق نمو مستدام وقيمة إضافية لحقوق المساهمين مع دعم الحلول التي تعزز الحياة.' }}</p>
                                </div>
                            </div>
                            <div class="col-sm-5 col-lg-5 wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                                <div class="speciality-inner row" style="padding: 35px 0px !important;">
                                    <h3>{{ language == 'en'? 'OUR VALUES ':'قيمنا ' }}</h3>
                                    <div class="col-lg-4">
                                        <ul>
                                            <li>{{ language == 'en'? 'Wisdom ':' الحكمة' }}</li>
                                            <li>{{ language == 'en'? 'Integrity  ':'النزاهة' }}</li>
                                            <li>{{ language == 'en'? 'Excellence ':'التميز' }}</li>   
                                        </ul>
                                    </div>
                                   <div class="col-lg-6">
                                    <ul>                                     
                                        <li>{{ language == 'en'? 'Collaboration ':'التعاون' }}</li>
                                        <li>{{ language == 'en'? 'Impact ':'التأثير' }}</li>
                                    </ul>
                                   </div>                                   
                                </div>
                            </div>
                            <div class="col-sm-7 col-lg-7 wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                                <div class="speciality-inner">
                                    <h3>{{ language == 'en'? 'OUR VISION ':'رؤيتنا' }}</h3>
                                    <p>{{ language == 'en'? 'To be the optimal investment platform in the healthcare sector, to enable our investors to access distinctive opportunities. We will reshape the standards of investing in healthcare to positively impact public health through a diverse portfolio.':
                                        'أن نكون منصة الاستثمار الامثل في مجال الرعاية الصحية، لتمكين مستثمريها من الوصول إلى فرص مميزة. سنعيد تشكيل معايير الاستثمار في الرعاية الصحية لتؤثر بشكل إيجابي على الصحة العامة من خلال محفظة متنوعة.' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4" style="margin-top:150px">
                <div class="about-item">
                    <div class="about-left">
                        <img src="assets/img/home-one/bg4.jpg" alt="Contact">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>-->